import { IonItem } from "@ionic/react";
import { ComponentProps } from "react";

import styles from "@components/ListItem.module.css";

type Props = Omit<ComponentProps<typeof IonItem>, "disabled"> & {
  selected?: boolean;
};

const ListItem = ({ children, className, selected = false, ...itemProps }: Props) => {
  const wrapperStyles = [styles.listItem];
  if (className) wrapperStyles.push(className);

  if (selected) wrapperStyles.push(styles.selected);

  return (
    <IonItem className={wrapperStyles.join(" ")} detail={false} disabled={selected} lines="none" {...itemProps}>
      {children}
    </IonItem>
  );
};

export default ListItem;
